import { render, staticRenderFns } from "./AnexoManuais.vue?vue&type=template&id=1a70cf8b"
import script from "./AnexoManuais.vue?vue&type=script&lang=js"
export * from "./AnexoManuais.vue?vue&type=script&lang=js"
import style0 from "./AnexoManuais.vue?vue&type=style&index=0&id=1a70cf8b&prod&lang=sass&scope=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports